let dominioURL = 'one7';
if (window && window.location.hostname !== 'localhost') {
  const hostnameParts = window.location.hostname.split('.');
  dominioURL = hostnameParts[hostnameParts.length - 2];
}
export const CONFIG_AMBIENTE = `x-${dominioURL}-configuracoes-ambiente`;

export const getConfigAmbiente = () => {
  let configAmbiente = localStorage.getItem(CONFIG_AMBIENTE);
  if (configAmbiente) {
    configAmbiente = atob(configAmbiente);
    try {
      return JSON.parse(configAmbiente);
    } catch (er) {
      return false;
    }
  } else {
    return false;
  }
};

export const getConfigAmbienteDominio = () => {
  const configAmbiente = getConfigAmbiente();
  let dominio =
    configAmbiente && configAmbiente.sistema && configAmbiente.sistema.dominio
      ? configAmbiente.sistema.dominio
      : '';
  if (dominio === '') {
    const hostnameParts = window.location.hostname.split('.');
    dominio = hostnameParts[hostnameParts.length - 2];
  }
  return dominio;
};
